import { Slot } from '@radix-ui/react-slot';
import { VariantProps } from 'cva';
import { ComponentProps } from 'react';

import { cva } from '../cva';

const variants = cva({
    base: [
        'relative inline-block pb-3',
        'after:absolute after:inset-x-0 after:bottom-0 after:h-1 after:rounded-full after:bg-gradient-to-r after:from-[--gradient-start] after:to-[--gradient-end]',
    ],
    variants: {
        fill: {
            true: 'after:w-full',
            false: 'after:w-[126px]',
        },
    },
    defaultVariants: {
        fill: false,
    },
});

type BorderedTextProps = ComponentProps<'span'> & {
    asChild?: boolean;
    fill?: boolean;
} & VariantProps<typeof variants>;

export function BorderedText({ asChild, fill, ...props }: BorderedTextProps) {
    const Comp = asChild ? Slot : 'span';

    return <Comp {...props} className={variants({ ...props, fill })} />;
}
